import axios from "axios";

export const api = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Register the Bearer token interceptor at module init so the token is
// attached to every request, including those fired before components mount.
// authService is imported dynamically to avoid eagerly initializing MSAL
// when this module is loaded in test environments.
// Skip entirely when dev auth bypass is active — there is no real token.
if (import.meta.env.VITE_DEV_AUTH_BYPASS !== "true") {
  api.interceptors.request.use(
    async (config) => {
      const { authService } = await import("@/services/auth");
      const token = await authService.getAccessToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
}
